export default __webpack_public_path__ + "static/media/recipes_light.a66993f8.png";